import React from "react";

import Heading from "@common/components/Heading/Heading";
import Paragraph from "@common/components/Paragraph/Paragraph";
import * as MetricDetailsStyled from "main/pages/Release/views/MetricDetails/MetricDetails.styles";

export default function CrashFreeSessionsAboutView() {
  return (
    <div style={{ padding: "3.2rem 0" }}>
      <MetricDetailsStyled.MetricsCard>
        <Heading
          heading3
          marginBottom={24}
        >
          About
        </Heading>
        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          What it measures
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {"The percentage of user sessions that ended without a fatal crash."}
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          Why it matters
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "Crashes are the most visible failure mode of any app. Drops here correlate directly with bad reviews, churn, and support volume. It's the industry-standard stability metric — investors, partners, and app store reviewers all expect it."
          }
        </Paragraph>

        <Heading
          heading4
          marginBottom={16}
          fontWeight={"bold"}
        >
          How to use it
        </Heading>
        <Paragraph
          p1
          marginBottom={24}
        >
          {
            "A sudden drop usually points to a regression in a specific build, OS version, or device family. Open the Crashes module from here to see grouped, prioritized stack traces and isolate the cause."
          }
        </Paragraph>
      </MetricDetailsStyled.MetricsCard>
    </div>
  );
}
